// extracted by mini-css-extract-plugin
module.exports = {"wrap":"BriefOpenDecisions_wrap__RJHeg","heading":"BriefOpenDecisions_heading__s08tr","row":"BriefOpenDecisions_row__wOKAp","question":"BriefOpenDecisions_question__GRMHN"};